// extracted by mini-css-extract-plugin
export default {"modalOverlay":"pI-z","modalContent":"qI-z","header":"rI-z","close":"sI-z"};